import { render, staticRenderFns } from "./VDetailWarning.vue?vue&type=template&id=5cbd8510&scoped=true"
import script from "./VDetailWarning.vue?vue&type=script&setup=true&lang=ts"
export * from "./VDetailWarning.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VDetailWarning.vue?vue&type=style&index=0&id=5cbd8510&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbd8510",
  null
  
)

export default component.exports